import { Component, OnInit } from '@angular/core';
import { HelperProvider } from '../providers/helper.provider';
import { Page } from '../model/page';
import { Sube } from '../model/sube';
import { RestService } from '../providers/rest.service';
import { Talep } from 'src/model/talep';
import { Dashboard } from 'src/model/dashboard';
import { AnasayfaGrafikComponent } from 'src/anasayfa-grafik/anasayfa-grafik.component';

@Component({
  selector: 'app-anasayfa',
  templateUrl: './anasayfa.component.html',
  styleUrls: ['./anasayfa.component.css']
})
export class AnasayfaComponent implements OnInit {

  /**
   * 
   * @param helperProvider 
   * @param restService apiler çağırılır.
   */
  constructor(private helperProvider: HelperProvider,
    private restService: RestService,) {
  }

  /**
   * Ana sayfadaki gösterilecek olan verilerin bilgisini tutar
   */
  dashboard: Dashboard = null;

  /**
   * Şube verilerini tutmak için kullanılır.
   */
  subeler: Sube[] = null;
  grafikler: any[] = [];

  /**
   * Arayüzden seçilen şubenin idsini tutmak için kullanılır.
   */
  selectedSubeId: number = null;

  subes: any = null;

  ngOnInit(): void {
    this.helperProvider.currentPage$.next(Page.Anasayfa);
    //this.getSubeler();
    this.getAllSubeTalep();
  }

  getSubeler() {
    this.restService.subeler().subscribe(res => {
      if (res != null) {
        this.subeler = res;
      }
    }, error => {
      this.helperProvider.showConnectionError$.next(true);
    });
  }

  getAllSubeTalep(){
    this.restService.getAllSubeTalep().subscribe(res => {
      if (res != null) {
        this.subes = res;
      }
    }, error => {
      this.helperProvider.showConnectionError$.next(true);
    });
  }


  /**
   * Şube seçiminde çalışır
   * @param id seçilen şubenin id'sini verir. 
   */
  onChange(id: number): void {
    this.selectedSubeId = id;
    if (this.selectedSubeId > 0) {
      this.restService.getSubeTalep(this.selectedSubeId).subscribe(res => {
        if (res != null) {
          this.dashboard = res;
        }
      }, error => {
        this.helperProvider.showConnectionError$.next(true);
      });
    } else {
      this.dashboard = null;
    }
  }
}
